/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_It9MuaUN9",
    "aws_cognito_identity_pool_id": "us-east-1:cc24aac6-0949-4233-9587-755080f9a713",
    "aws_user_pools_web_client_id": "4put5cm1u6anfdaocte6lrun1o",
    "aws_mobile_analytics_app_id": "67abe4ee11a041a89eb944d3a1149a2d",
    "aws_mobile_analytics_app_region": "us-east-1",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "67abe4ee11a041a89eb944d3a1149a2d",
            "region": "us-east-1"
        }
    },
    "Notifications": {
        "Push": {
            "AWSPinpoint": {
                "appId": "67abe4ee11a041a89eb944d3a1149a2d",
                "region": "us-east-1"
            }
        },
        "Email": {
            "AWSPinpoint": {
                "appId": "67abe4ee11a041a89eb944d3a1149a2d",
                "region": "us-east-1"
            }
        },
        "SMS": {
            "AWSPinpoint": {
                "appId": "67abe4ee11a041a89eb944d3a1149a2d",
                "region": "us-east-1"
            }
        }
    },
    "aws_cloud_logic_custom": [
        {
            "name": "clarityCore",
            "endpoint": "https://f9a33pm418.execute-api.us-east-1.amazonaws.com/main",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:36bfc38d-429c-4d28-a99f-464b6bd7b1a3",
    "aws_cognito_region": "us-east-1",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": []
};


export default awsmobile;
